import { UseFormRegisterReturn } from 'react-hook-form';

type FormInputProps = {
  text: string;
  size?: number;
  maxLength?: number;
  placeHolder?: string;
  readOnly?: boolean;
  type?: React.HTMLInputTypeAttribute;
  formRegister: UseFormRegisterReturn<any>;
  errorMessage?: string;
  testId: string;
};

const FormInput = ({
  text,
  size,
  placeHolder,
  readOnly = false,
  type,
  formRegister,
  errorMessage,
  testId,
}: FormInputProps) => {
  return (
    <>
      <div>{text}</div>
      <div className="flex">
        <input
          className="mt-1 rounded-lg border px-2 py-3 shadow-sm focus:outline-sky-200"
          readOnly={readOnly}
          placeholder={placeHolder}
          type={type}
          size={size}
          {...formRegister}
          data-cy={testId}
        />
      </div>
      <div className="mt-1 text-red-500" data-cy={`${testId}-error`}>
        {errorMessage && errorMessage}
      </div>
    </>
  );
};

export default FormInput;
